import React, { useEffect } from "react";
import { Modal, Form, message } from "antd";
import CustomListItemForm from "./CustomListItemForm";
import { WebApiCustomListsDtoCreateCustomListItemDto, WebApiCustomListsDtoCustomListItemDto, WebApiMemberDtoMemberDto, WebApiModelsCustomListField } from "../../Repository/eventbookyapi";
import { UiControlType } from "../../Types/UiControlType";
import { CustomListItemService } from "../../Services/CustomListItemService";
import { TextService } from "../../Services/TextService";

interface CustomListAddModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: () => void;
    customFields: WebApiModelsCustomListField[];
    customListId: number;
    member?: WebApiMemberDtoMemberDto | undefined;
}

const CustomListAddModal: React.FC<CustomListAddModalProps> = ({
    open,
    onClose,
    onSuccess,
    customFields,
    customListId,
    member
}) => {
    const [form] = Form.useForm();
    const [lookupOptions, setLookupOptions] = React.useState<WebApiCustomListsDtoCustomListItemDto[]>([]);
    const GetText = TextService.GetText;

    useEffect(() => {
        if (open) {
            const initialValues: any = {};
            const fetchLookups = async () => {
                for (const field of customFields) {
                    initialValues[String(field.id)] = (field.uiControl === UiControlType.YesNo) ? false : undefined;
                    if (field.uiControl === UiControlType.Lookup && field.lookupListId && field.id !== undefined) {
                        const items = await CustomListItemService.GetItems(field.lookupListId);
                        setLookupOptions(items);
                    }
                }
                form.setFieldsValue(initialValues);
            };
            fetchLookups();
        }
    }, [open, customFields, form]);

    const handleOk = async () => {
        try {
            const allFieldIds = customFields.map((field: any) => String(field.id));
            allFieldIds.forEach(fid => {
                if (form.getFieldValue(fid) === undefined) form.setFieldValue(fid, null);
            });
            const values = await form.validateFields();
            const newItem: WebApiCustomListsDtoCreateCustomListItemDto = {
                customListId: Number(customListId),
                memberId: member?.memberId,
                fieldValues: Object.entries(values).map(([fieldId, fieldValue]) => ({
                    fieldId: Number(fieldId),
                    fieldValue: fieldValue != null ? fieldValue : "",
                })),
            };
            await CustomListItemService.CreateCustomListItem(newItem);
            message.success(GetText("CustomList_ItemAdded") || "Added!");
            onClose();
            if (onSuccess) onSuccess();
        } catch (e) {
            message.error(GetText("CustomList_FailedToAdd") || "Could not add the item.");
        }
    };

    return (
        <Modal
            title={GetText("CustomList_AddItem") || "Add Item"}
            open={open}
            onOk={handleOk}
            onCancel={onClose}
            okText={GetText("Common_Save") || "Save"}
            cancelText={GetText("Common_Cancel") || "Cancel"}
            destroyOnClose
        >
            <CustomListItemForm
                form={form}
                customFields={customFields}
                mode="add"
                lookupOptions={lookupOptions}

            />
        </Modal>
    );
};

export default CustomListAddModal;
